import {
  HomePage, ProfilePage, Page404, SystemOtoIndex,
  SettingUserIndex, SettingUserAdd, SettingUserDetail,
  SettingRoleIndex, SettingRoleAdd, SettingRoleDetail,
  SettingMenuIndex, SettingMenuAdd, SettingMenuDetail,
  SettingDoctagIndex, SettingDoctagAdd, SettingDoctagDetail,
  HrDivisiIndex, HrDivisiAdd, HrDivisiDetail,
  HrJabatanIndex, HrJabatanAdd, HrJabatanDetail,
  HrStaffIndex, HrStaffAdd, HrStaffDetail,
  MmSatuanIndex, MmSatuanAdd, MmSatuanDetail,
  MmKonversiSatuanIndex, MmKonversiSatuanAdd, MmKonversiSatuanDetail,
  MmDivisiBarangIndex, MmDivisiBarangAdd, MmDivisiBarangDetail,
  MmKelompokBarangIndex, MmKelompokBarangAdd, MmKelompokBarangDetail,
  MmJenisBarangIndex, MmJenisBarangAdd, MmJenisBarangDetail,
  MmKelasBarangIndex, MmKelasBarangAdd, MmKelasBarangDetail,
  MmGudangIndex, MmGudangAdd, MmGudangDetail,
  MmSubGudangIndex, MmSubGudangAdd, MmSubGudangDetail,
  MmMasterBarangIndex, MmMasterBarangAdd, MmMasterBarangDetail,
  MmMasterBatchIndex, MmMasterBatchAdd, MmMasterBatchDetail,
  MmHargaBarangIndex, MmHargaBarangAdd, MmHargaBarangDetail,
  AccAccountIndex, LabaRugiIndex,
  SalesProductIndex, SalesProductAdd, SalesProductDetail,
  SalesModelIndex, SalesModelAdd, SalesModelDetail,
  SalesCustomerClassIndex, SalesCustomerClassAdd, SalesCustomerClassDetail,
  SalesCustomerIndex, SalesCustomerAdd, SalesCustomerDetail,
  SalesMasterSalesmanIndex, SalesMasterSalesmanAdd, SalesMasterSalesmanDetail,
  SalesLeadsIndex, SalesLeadsAdd, SalesLeadsDetail,
  PurchasingKelasSupplierIndex, PurchasingKelasSupplierAdd, PurchasingKelasSupplierDetail,
  PurchasingSupplierIndex, PurchasingSupplierAdd, PurchasingSupplierDetail,
  PurchasingPRIndex, PurchasingPRAdd, PurchasingPRDetail,
  PurchasingInquiryIndex, PurchasingInquiryAdd, PurchasingInquiryDetail,
  PurchasingPOIndex, PurchasingPOAdd, PurchasingPODetail,
  PurchasingGRIndex, PurchasingGRAdd, PurchasingGRDetail, PurchasingGRDetailKain,
  MmTransferStokIndex, MmTransferStokAdd, MmTransferStokDetail, SalesQuotationAdd, SalesQuotationDetail, SalesQuotationIndex, SalesSalesOrderIndex, SalesSalesOrderAdd, SalesSalesOrderDetail,
  ProductionWorkOrderIndex, ProductionWorkOrderAdd, ProductionWorkOrderDetail, RequestChangeWorkOrderIndex, MmUsageAdd, MmUsageDetail, MmUsageIndex, MmReclassIndex, MmReclassAdd, MmReclassDetail, ProductionInputProduksiDetail,
  GudangUmumIndex, GudangIndex, GudangBahanBakuIndex, GudangKainIndex, GudangKainGrAdd, GudangKainGrDetail, GudangBahanBaku17Index, GudangBarangJadi17Index, GudangBarangJadiIndex,
  PenggunaanBarangIndex, PenggunaanBarangDaftarProses, PenggunaanBarangTambahPenggunaan, PenggunaanBarangList, PenggunaanBarangEditPenggunaan, PenggunaanBarangJoblist,
  DashboardJoblist, DashboardPermintaanGudang, ProductionBhpIndex, ProductionBhpAdd, ProductionBhpDetail, ProductionBhpAddWO, UsageKainIndex, UsageKainDetail,
  SalesDeliveryOrderIndex, HistoryChatIndex, HistoryChatImportIndex,
  SalesDeliveryOrderAddSo,
  SalesDeliveryOrderDetail, KartuPiutangIndex, KartuHutangIndex, OmniProductPriceIndex,
  AccInvoiceIndex, AccInvoiceDetail, AccInvoiceAddDo, InvoiceReceiptIndex, InvoiceReceiptAdd, InvoiceReceiptDetail,
  GudangViewOpnameKain, GudangViewOpname, PosIndex, PosImportIndex, PosLaporanIndex, GudangViewOpnameNew,
  GeneralLedgerIndex, NeracaIndex, MutasiKasBankIndex, MutasiKasBankAdd, MutasiKasBankDetail,
  JurnalMemorialIndex, JurnalMemorialAdd, JurnalMemorialDetail, PostingJurnalIndex, RekalkulasiPersediaanIndex, ProductionInputProduksi17Index,
  PrBahanBakuIndex, PostingIndex, BukuBesarIndex,
  ListInputProduksiIndex, ProductionPlanningProduksiIndex, ProductionJadwalProduksi17Index, ProductionJadwalProduksiRangkahIndex, ReportMrpIndex, ReportValuasiStockIndex, ReportValuasiStockWHIndex, AccValuasiBarangIndex, ReportProductionBoardIndex,
  KontakOmniIndex, ChatCustomerOmniIndex, KalenderAktifitasIndex, InboundIndex,
  ProductionPermintaanPreview, ProductionPermintaanPreviewAdd, ProductionPermintaanPreviewDetail,
  DpCustomerIndex, DpVendorIndex, AccAppIndex, AccArrIndex, AccAppAdd, AccAppDetail, AccArrAdd, AccArrDetail,
  AccKalkulasiWoIndex, AccKalkulasiWoDetail,
  MkddProsesProduksiIndex, MkddProsesProduksiAdd, MkddProsesProduksiEdit, KddWorkOrderIndex, KddProgressWorkOrderIndex, KddInputProduksiIndex,
  KddPencairanUpahIndex, KddPencairanUpahAdd, KddPencairanUpahDetail,
  MemoArIndex, MemoApIndex, JasaWorkOrderIndex, ApprovalWOIndex, ReportDynamicMenu, ProductionWorkOrderSimpleIndex, ProductionWorkOrderSimpleDetail,
  ReportDynamicDetail, ReportPerolehanKedindingIndex, ReportPerbandinganUpahKedindingIndex,
  OmniShopeeIndex, OmniShopeeImport, OmniShopeePenjualanImport, OmniShopeeReturImport,
  OmniTiktokIndex, OmniTiktokImport, OmniTiktokPenjualanImport, OmniTiktokReturImport,
  RekapNilaiPersediaanIndex,
  RekeningKoranBcaIndex, RekeningKoranBcaImport, SaldoAwalIndex, SaldoKaryawanIndex,
  MasterMakloonIndex, MasterMakloonAdd, MasterMakloonAddPr, MasterMakloonAddPo, MasterMakloonAddGr, MasterMakloonDetail,
  ProfitcenterIndex, ProfitcenterAdd, ProfitcenterDetail, TerimaHasilProduksiIndex, TerimaHasilProduksiDetail, LaporanPencairanIndex, LaporanSalesOrderIndex
} from '../pages';
import { withNavigationWatcher } from '../contexts/navigation';

const routes = [
  {
    path: '/404',
    element: Page404
  },
  {
    path: '/profile',
    element: ProfilePage
  },
  {
    path: '/',
    element: HomePage
  },
  {
    path: '/system/otorisasi',
    element: SystemOtoIndex
  },
  {
    path: '/system/pos',
    element: PosIndex
  },
  {
    path: '/system/pos/import',
    element: PosImportIndex
  },
  {
    path: '/system/pos/laporan',
    element: PosLaporanIndex
  },
  {
    path: '/setting/user',
    element: SettingUserIndex
  },
  {
    path: '/setting/user/add',
    element: SettingUserAdd
  },
  {
    path: '/setting/user/detail/:id',
    element: SettingUserDetail
  },
  {
    path: '/setting/role',
    element: SettingRoleIndex
  },
  {
    path: '/setting/role/add',
    element: SettingRoleAdd
  },
  {
    path: '/setting/role/detail/:id',
    element: SettingRoleDetail
  },
  {
    path: '/setting/menu',
    element: SettingMenuIndex
  },
  {
    path: '/setting/menu/add',
    element: SettingMenuAdd
  },
  {
    path: '/setting/menu/detail/:id',
    element: SettingMenuDetail
  },
  {
    path: '/setting/doctag',
    element: SettingDoctagIndex
  },
  {
    path: '/setting/doctag/add',
    element: SettingDoctagAdd
  },
  {
    path: '/setting/doctag/detail/:id',
    element: SettingDoctagDetail
  },
  {
    path: '/hr/divisi',
    element: HrDivisiIndex
  },
  {
    path: '/hr/divisi/add',
    element: HrDivisiAdd
  },
  {
    path: '/hr/divisi/detail/:id',
    element: HrDivisiDetail
  },
  {
    path: '/hr/jabatan',
    element: HrJabatanIndex
  },
  {
    path: '/hr/jabatan/add',
    element: HrJabatanAdd
  },
  {
    path: '/hr/jabatan/detail/:id',
    element: HrJabatanDetail
  },
  {
    path: '/hr/staff',
    element: HrStaffIndex
  },
  {
    path: '/hr/staff/add',
    element: HrStaffAdd
  },
  {
    path: '/hr/staff/detail/:id',
    element: HrStaffDetail
  },
  {
    path: '/mm/satuan',
    element: MmSatuanIndex
  },
  {
    path: '/mm/satuan/add',
    element: MmSatuanAdd
  },
  {
    path: '/mm/satuan/detail/:id',
    element: MmSatuanDetail
  },
  {
    path: '/mm/konversi-satuan',
    element: MmKonversiSatuanIndex
  },
  {
    path: '/mm/konversi-satuan/add',
    element: MmKonversiSatuanAdd
  },
  {
    path: '/mm/konversi-satuan/detail/:id',
    element: MmKonversiSatuanDetail
  },
  {
    path: '/mm/divisi-barang',
    element: MmDivisiBarangIndex
  },
  {
    path: '/mm/divisi-barang/add',
    element: MmDivisiBarangAdd
  },
  {
    path: '/mm/divisi-barang/detail/:id',
    element: MmDivisiBarangDetail
  },
  {
    path: '/mm/kelompok-barang',
    element: MmKelompokBarangIndex
  },
  {
    path: '/mm/kelompok-barang/add',
    element: MmKelompokBarangAdd
  },
  {
    path: '/mm/kelompok-barang/detail/:id',
    element: MmKelompokBarangDetail
  },
  {
    path: '/mm/jenis-barang',
    element: MmJenisBarangIndex
  },
  {
    path: '/mm/jenis-barang/add',
    element: MmJenisBarangAdd
  },
  {
    path: '/mm/jenis-barang/detail/:id',
    element: MmJenisBarangDetail
  },
  {
    path: '/mm/kelas-barang',
    element: MmKelasBarangIndex
  },
  {
    path: '/mm/kelas-barang/add',
    element: MmKelasBarangAdd
  },
  {
    path: '/mm/kelas-barang/detail/:id',
    element: MmKelasBarangDetail
  },
  {
    path: '/mm/master-gudang',
    element: MmGudangIndex
  },
  {
    path: '/mm/master-gudang/add',
    element: MmGudangAdd
  },
  {
    path: '/mm/master-gudang/detail/:id',
    element: MmGudangDetail
  },
  {
    path: '/mm/master-subgudang',
    element: MmSubGudangIndex
  },
  {
    path: '/mm/master-subgudang/add',
    element: MmSubGudangAdd
  },
  {
    path: '/mm/master-subgudang/detail/:id',
    element: MmSubGudangDetail
  },
  {
    path: '/mm/master-barang',
    element: MmMasterBarangIndex
  },
  {
    path: '/mm/master-barang',
    element: MmMasterBarangIndex
  },
  {
    path: '/mm/master-barang/add',
    element: MmMasterBarangAdd
  },
  {
    path: '/mm/master-barang/detail/:id',
    element: MmMasterBarangDetail
  },
  {
    path: '/mm/master-batch',
    element: MmMasterBatchIndex
  },
  {
    path: '/mm/master-batch/add',
    element: MmMasterBatchAdd
  },
  {
    path: '/mm/master-batch/detail/:id',
    element: MmMasterBatchDetail
  },
  {
    path: '/mm/harga-barang',
    element: MmHargaBarangIndex
  },
  {
    path: '/mm/harga-barang/add',
    element: MmHargaBarangAdd
  },
  {
    path: '/mm/harga-barang/detail/:id',
    element: MmHargaBarangDetail
  },
  {
    path: '/mm/usage',
    element: MmUsageIndex
  },
  {
    path: '/mm/usage/add',
    element: MmUsageAdd
  },
  {
    path: '/mm/usage/detail/:id',
    element: MmUsageDetail
  },
  {
    path: '/mm/transfer-stok',
    element: MmTransferStokIndex
  },
  {
    path: '/mm/transfer-stok/add',
    element: MmTransferStokAdd
  },
  {
    path: '/mm/transfer-stok/detail/:id',
    element: MmTransferStokDetail
  },
  {
    path: '/mm/reclass',
    element: MmReclassIndex
  },
  {
    path: '/mm/reclass/add',
    element: MmReclassAdd
  },
  {
    path: '/mm/reclass/detail/:id',
    element: MmReclassDetail
  },
  {
    path: '/acc/profitcenter',
    element: ProfitcenterIndex
  },
  {
    path: '/acc/profitcenter/add',
    element: ProfitcenterAdd
  },
  {
    path: '/acc/profitcenter/detail/:id',
    element: ProfitcenterDetail
  },
  {
    path: '/acc/master-account',
    element: AccAccountIndex
  },
  {
    path: '/acc/invoice',
    element: AccInvoiceIndex
  },
  {
    path: '/acc/invoice/detail/:id',
    element: AccInvoiceDetail
  },
  {
    path: '/acc/invoice/add-do/:id',
    element: AccInvoiceAddDo
  },
  {
    path: '/acc/invoice-receipt',
    element: InvoiceReceiptIndex
  },
  {
    path: '/acc/invoice-receipt/add',
    element: InvoiceReceiptAdd
  },
  {
    path: '/acc/invoice-receipt/detail/:id',
    element: InvoiceReceiptDetail
  },
  {
    path: '/acc/general-ledger',
    element: GeneralLedgerIndex
  },
  {
    path: '/acc/neraca',
    element: NeracaIndex
  },
  {
    path: '/acc/laba-rugi',
    element: LabaRugiIndex
  },
  {
    path: '/acc/mutasi-kas-bank',
    element: MutasiKasBankIndex
  },
  {
    path: '/acc/mutasi-kas-bank/add',
    element: MutasiKasBankAdd
  },
  {
    path: '/acc/mutasi-kas-bank/detail/:id',
    element: MutasiKasBankDetail
  },
  {
    path: '/acc/jurnal-memorial',
    element: JurnalMemorialIndex
  },
  {
    path: '/acc/jurnal-memorial/add',
    element: JurnalMemorialAdd
  },
  {
    path: '/acc/jurnal-memorial/detail/:id',
    element: JurnalMemorialDetail
  },
  {
    path: '/acc/posting-jurnal',
    element: PostingJurnalIndex
  },
  {
    path: '/acc/rekalkulasi-persediaan',
    element: RekalkulasiPersediaanIndex
  },
  {
    path: '/acc/posting',
    element: PostingIndex
  },
  {
    path: '/acc/buku-besar',
    element: BukuBesarIndex
  },
  {
    path: '/acc/rekap-nilai-persediaan',
    element: RekapNilaiPersediaanIndex
  },
  {
    path: '/acc/dp-customer',
    element: DpCustomerIndex
  }, {
    path: '/acc/dp-vendor',
    element: DpVendorIndex
  }, {
    path: '/acc/app',
    element: AccAppIndex
  }, {
    path: '/acc/app/add',
    element: AccAppAdd
  }, {
    path: '/acc/app/detail/:id',
    element: AccAppDetail
  },
  {
    path: '/acc/arr',
    element: AccArrIndex
  }, {
    path: '/acc/arr/add',
    element: AccArrAdd
  }, {
    path: '/acc/arr/detail/:id',
    element: AccArrDetail
  },
  {
    path: '/acc/kalkulasi-wo',
    element: AccKalkulasiWoIndex
  },
  {
    path: '/acc/kartu-hutang',
    element: KartuHutangIndex
  },
  {
    path: '/acc/kartu-piutang',
    element: KartuPiutangIndex
  },
  {
    path: '/acc/kalkulasi-wo/detail/:id',
    element: AccKalkulasiWoDetail
  },
  {
    path: '/sales/product',
    element: SalesProductIndex
  },
  {
    path: '/sales/model',
    element: SalesModelIndex
  },
  {
    path: '/sales/product/add',
    element: SalesProductAdd
  },
  {
    path: '/sales/product/detail/:id',
    element: SalesProductDetail
  },
  {
    path: '/sales/model/add',
    element: SalesModelAdd
  },
  {
    path: '/sales/model/detail/:id',
    element: SalesModelDetail
  },
  {
    path: '/sales/master-customer-class',
    element: SalesCustomerClassIndex
  },
  {
    path: '/sales/master-customer-class/add',
    element: SalesCustomerClassAdd
  },
  {
    path: '/sales/master-customer-class/detail/:id',
    element: SalesCustomerClassDetail
  },
  {
    path: '/sales/master-customer',
    element: SalesCustomerIndex
  },
  {
    path: '/sales/master-customer/add',
    element: SalesCustomerAdd
  },
  {
    path: '/sales/master-customer/detail/:id',
    element: SalesCustomerDetail
  },
  {
    path: '/sales/master-salesman',
    element: SalesMasterSalesmanIndex
  },
  {
    path: '/sales/master-salesman/add',
    element: SalesMasterSalesmanAdd
  },
  {
    path: '/sales/master-salesman/detail/:id',
    element: SalesMasterSalesmanDetail
  },
  {
    path: '/sales/leads',
    element: SalesLeadsIndex
  },
  {
    path: '/sales/leads/add',
    element: SalesLeadsAdd
  },
  {
    path: '/sales/leads/detail/:id',
    element: SalesLeadsDetail
  },
  {
    path: '/sales/quotation',
    element: SalesQuotationIndex
  },
  {
    path: '/sales/quotation/add',
    element: SalesQuotationAdd
  },
  {
    path: '/sales/quotation/detail/:id',
    element: SalesQuotationDetail
  },
  {
    path: '/sales/sales-order',
    element: SalesSalesOrderIndex
  },
  {
    path: '/sales/sales-order/add',
    element: SalesSalesOrderAdd
  },
  {
    path: '/sales/sales-order/detail/:id',
    element: SalesSalesOrderDetail
  },
  {
    path: '/sales/delivery-order',
    element: SalesDeliveryOrderIndex
  },
  {
    path: '/sales/delivery-order/detail/:id',
    element: SalesDeliveryOrderDetail
  },
  {
    path: '/sales/delivery-order/add-so/:id',
    element: SalesDeliveryOrderAddSo
  },
  {
    path: '/production/work-order-simple',
    element: ProductionWorkOrderSimpleIndex
  },
  {
    path: '/production/work-order-simple/detail/:id',
    element: ProductionWorkOrderSimpleDetail
  },
  {
    path: '/production/work-order',
    element: ProductionWorkOrderIndex
  },
  {
    path: '/production/request-change-work-order',
    element: RequestChangeWorkOrderIndex
  },
  {
    path: '/production/jasa-work-order',
    element: JasaWorkOrderIndex
  },
  {
    path: '/production/approval-work-order',
    element: ApprovalWOIndex
  },
  {
    path: '/production/work-order/add',
    element: ProductionWorkOrderAdd
  },
  {
    path: '/production/work-order/detail/:id',
    element: ProductionWorkOrderDetail
  },
  {
    path: '/production/planning-produksi',
    element: ProductionPlanningProduksiIndex
  },
  {
    path: '/production/jadwal-produksi-rangkah',
    element: ProductionJadwalProduksiRangkahIndex
  },
  {
    path: '/production/jadwal-produksi-17',
    element: ProductionJadwalProduksi17Index
  },
  {
    path: '/production/input-produksi/:id',
    element: ProductionInputProduksiDetail
  },
  {
    path: '/production/input-produksi',
    element: ListInputProduksiIndex
  },
  {
    path: '/production/input-produksi-17',
    element: ProductionInputProduksi17Index
  },
  {
    path: '/production/bhp',
    element: ProductionBhpIndex
  },
  {
    path: '/production/bhp/add',
    element: ProductionBhpAdd
  },
  {
    path: '/production/bhp/detail/:id',
    element: ProductionBhpDetail
  },
  {
    path: '/production/terima-hasil-produksi',
    element: TerimaHasilProduksiIndex
  },
  {
    path: '/production/terima-hasil-produksi/detail/:id',
    element: TerimaHasilProduksiDetail
  },
  {
    path: '/sales/laporan-pencairan',
    element: LaporanPencairanIndex
  },
  {
    path: '/sales/laporan-sales-order',
    element: LaporanSalesOrderIndex
  },
  {
    path: '/production/bhp/add-wo/:id',
    element: ProductionBhpAddWO
  }, {
    path: '/production/permintaan-preview',
    element: ProductionPermintaanPreview
  }, {
    path: '/production/permintaan-preview/add',
    element: ProductionPermintaanPreviewAdd
  }, {
    path: '/production/permintaan-preview/detail/:id',
    element: ProductionPermintaanPreviewDetail
  },
  {
    path: '/mkdd/proses-produksi',
    element: MkddProsesProduksiIndex
  },
  {
    path: '/mkdd/proses-produksi/add',
    element: MkddProsesProduksiAdd
  },
  {
    path: '/mkdd/proses-produksi/edit/:id',
    element: MkddProsesProduksiEdit
  },
  {
    path: '/kdd/work-order',
    element: KddWorkOrderIndex
  },
  {
    path: '/kdd/progress-work-order',
    element: KddProgressWorkOrderIndex
  },
  {
    path: '/kdd/input-produksi',
    element: KddInputProduksiIndex
  },
  {
    path: '/kdd/pencairan-upah',
    element: KddPencairanUpahIndex
  },
  {
    path: '/kdd/pencairan-upah/add',
    element: KddPencairanUpahAdd
  },
  {
    path: '/kdd/pencairan-upah/detail/:id',
    element: KddPencairanUpahDetail
  },
  {
    path: '/purchasing/kelas-supplier',
    element: PurchasingKelasSupplierIndex
  },
  {
    path: '/purchasing/kelas-supplier/add',
    element: PurchasingKelasSupplierAdd
  },
  {
    path: '/purchasing/kelas-supplier/detail/:id',
    element: PurchasingKelasSupplierDetail
  },
  {
    path: '/purchasing/supplier',
    element: PurchasingSupplierIndex
  },
  {
    path: '/purchasing/supplier/add',
    element: PurchasingSupplierAdd
  },
  {
    path: '/purchasing/supplier/detail/:id',
    element: PurchasingSupplierDetail
  },
  {
    path: '/purchasing/purchase-request',
    element: PurchasingPRIndex
  },
  {
    path: '/purchasing/purchase-request/add',
    element: PurchasingPRAdd
  },
  {
    path: '/purchasing/purchase-request/detail/:id',
    element: PurchasingPRDetail
  },
  {
    path: '/purchasing/master-makloon',
    element: MasterMakloonIndex
  },
  {
    path: '/purchasing/master-makloon/add',
    element: MasterMakloonAdd
  }, {
    path: '/purchasing/master-makloon/add-pr',
    element: MasterMakloonAdd
  }, {
    path: '/purchasing/master-makloon/add-po',
    element: MasterMakloonAdd
  }, {
    path: '/purchasing/master-makloon/add-gr',
    element: MasterMakloonAdd
  },
  {
    path: '/purchasing/master-makloon/detail/:id',
    element: MasterMakloonDetail
  },
  {
    path: '/purchasing/inquiry',
    element: PurchasingInquiryIndex
  },
  {
    path: '/purchasing/inquiry/add',
    element: PurchasingInquiryAdd
  },
  {
    path: '/purchasing/inquiry/detail/:id',
    element: PurchasingInquiryDetail
  },
  {
    path: '/purchasing/purchase-order',
    element: PurchasingPOIndex
  },
  {
    path: '/purchasing/purchase-order/add/:id',
    element: PurchasingPOAdd
  },
  {
    path: '/purchasing/purchase-order/detail/:id',
    element: PurchasingPODetail
  },
  {
    path: '/purchasing/good-receipt',
    element: PurchasingGRIndex
  },
  {
    path: '/purchasing/good-receipt/add/:id',
    element: PurchasingGRAdd
  },
  {
    path: '/purchasing/good-receipt/detail/:id',
    element: PurchasingGRDetail
  },
  {
    path: '/purchasing/good-receipt/detail-kain/:id',
    element: PurchasingGRDetailKain
  },
  {
    path: '/purchasing/pr-bahan-baku',
    element: PrBahanBakuIndex
  },
  {
    path: '/gudang/:id',
    element: GudangIndex
  },
  {
    path: '/gudang/view-opname/:id',
    element: GudangViewOpname
  },
  {
    path: '/gudang/view-opname-new/:id',
    element: GudangViewOpnameNew
  },
  {
    path: '/gudang/view-opname-kain/:id',
    element: GudangViewOpnameKain
  },
  {
    path: '/mm/gudang/umum',
    element: GudangUmumIndex
  },
  {
    path: '/mm/gudang/bahan-baku',
    element: GudangBahanBakuIndex
  },
  {
    path: '/mm/gudang/kain',
    element: GudangKainIndex
  },
  {
    path: '/mm/gudang/kain/add/:id',
    element: GudangKainGrAdd
  },
  {
    path: '/mm/gudang/kain/detail/:id',
    element: GudangKainGrDetail
  },
  {
    path: '/mm/gudang/barang-jadi',
    element: GudangBarangJadiIndex
  },
  {
    path: '/mm/gudang/bahan-baku-17',
    element: GudangBahanBaku17Index
  },
  {
    path: '/mm/gudang/barang-jadi-17',
    element: GudangBarangJadi17Index
  },
  {
    path: '/mm/penggunaan-barang',
    element: PenggunaanBarangIndex,
  },
  {
    path: '/mm/penggunaan-barang/daftar-proses',
    element: PenggunaanBarangDaftarProses,
  },
  {
    path: '/mm/penggunaan-barang/tambah-penggunaan',
    element: PenggunaanBarangTambahPenggunaan,
  },
  {
    path: '/mm/penggunaan-barang/list-penggunaan',
    element: PenggunaanBarangList,
  },
  {
    path: '/mm/penggunaan-barang/edit-penggunaan/:id',
    element: PenggunaanBarangEditPenggunaan
  },
  {
    path: '/mm/penggunaan-barang/joblist',
    element: PenggunaanBarangJoblist
  },
  {
    path: '/dashboards/joblist',
    element: DashboardJoblist,
  },
  {
    path: '/dashboards/permintaan-gudang',
    element: DashboardPermintaanGudang,
  },
  {
    path: '/mm/usage-kain',
    element: UsageKainIndex,
  },
  {
    path: '/mm/usage-kain/detail/:id',
    element: UsageKainDetail,
  },
  {
    path: '/report/mrp',
    element: ReportMrpIndex
  },
  {
    path: '/acc/valuasi-barang',
    element: AccValuasiBarangIndex
  },
  {
    path: '/report/valuasi-stock',
    element: ReportValuasiStockIndex
  },
  {
    path: '/report/valuasi-stock-wh',
    element: ReportValuasiStockWHIndex
  },
  {
    path: '/report/production-board',
    element: ReportProductionBoardIndex
  },
  {
    path: '/report/dynamic/:menu',
    element: ReportDynamicMenu,
  },
  {
    path: '/report/detail/:id',
    element: ReportDynamicDetail,
  },
  {
    path: '/report/kedinding/perolehan',
    element: ReportPerolehanKedindingIndex,
  },
  {
    path: '/report/kedinding/perbandingan-upah',
    element: ReportPerbandinganUpahKedindingIndex,
  },
  {
    path: '/omni/kontak',
    element: KontakOmniIndex
  },
  {
    path: '/omni/chat-customer',
    element: ChatCustomerOmniIndex
  },
  {
    path: '/omni/kalender-aktifitas',
    element: KalenderAktifitasIndex
  },
  {
    path: '/omni/inbound',
    element: InboundIndex
  },
  {
    path: '/omni/shopee',
    element: OmniShopeeIndex
  }, {
    path: '/omni/product-price',
    element: OmniProductPriceIndex
  }, {
    path: '/omni/shopee/import',
    element: OmniShopeeImport
  }, {
    path: '/omni/shopee/import-penjualan',
    element: OmniShopeePenjualanImport
  }, {
    path: '/omni/shopee/import-retur',
    element: OmniShopeeReturImport
  },
  {
    path: '/omni/tiktok',
    element: OmniTiktokIndex
  }, {
    path: '/omni/tiktok/import',
    element: OmniTiktokImport
  }, {
    path: '/omni/tiktok/import-penjualan',
    element: OmniTiktokPenjualanImport
  }, {
    path: '/omni/tiktok/import-retur',
    element: OmniTiktokReturImport
  },
  {
    path: '/omni/history-chat',
    element: HistoryChatIndex
  },
  {
    path: '/omni/history-chat/import',
    element: HistoryChatImportIndex
  },
  {
    path: '/acc/rekening-koran-bca',
    element: RekeningKoranBcaIndex
  }, {
    path: '/acc/rekening-koran-bca/import',
    element: RekeningKoranBcaImport
  },
  {
    path: '/acc/memo-ar',
    element: MemoArIndex
  },
  {
    path: '/acc/memo-ap',
    element: MemoApIndex
  },
  {
    path: '/acc/saldo-awal',
    element: SaldoAwalIndex
  },
  {
    path: '/acc/saldo-karyawan',
    element: SaldoKaryawanIndex
  },
];

export default routes.map(route => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path)
  };
});
